import { useEffect, useState } from 'react';

import { CheckmateDialog } from '../dialog';
import CheckmateSelect from '../CheckmateSelect';
import { ICaseFileModel } from '../../../interfaces/ICaseFileModel';
import { IMultiSelectOption } from '../../../interfaces/ILookup';
import { ISameCaseMatchedCasesSearchModel } from '../../../pages/quad/same-cases-admin/manage/useGetSameCasesQuery';
import { Stack } from 'react-bootstrap';
import { ZoneGroupDetailsBody } from './ZoneGroupDetailsBody';
import { useCaseFileModelContext } from '../../../contexts/useCaseFileModelContext';

interface ISSameCaseCaseFileModelFilterProps {
    currentFilters: ISameCaseMatchedCasesSearchModel;
    setCurrentFilters: React.Dispatch<React.SetStateAction<ISameCaseMatchedCasesSearchModel>>;
}

export function SameCaseCaseFileModelFilter(props: ISSameCaseCaseFileModelFilterProps) {
    const [showZoneGroupDetails, setShowZoneGroupDetails] = useState(false);

    const { caseFileModelId, caseFileModelIdChange, userCaseFileModelsQuery } =
        useCaseFileModelContext();

    useEffect(() => {
        props.setCurrentFilters(() => ({
            ...props.currentFilters,
            caseFileModelId: caseFileModelId,
        }));
    }, [caseFileModelId]);

    const caseFileModelOptions =
        userCaseFileModelsQuery?.data?.map((d: ICaseFileModel) => {
            return { label: d.displayName, id: d.id, value: d.id.toString() } as IMultiSelectOption;
        }) ?? [];

    const handleCaseFileModelChange = (option: IMultiSelectOption | null) => {
        caseFileModelIdChange(option?.id ?? 0);
    };

    const handleToggleZoneGroupDetailsModal = () => {
        setShowZoneGroupDetails(true);
    };

    return (
        <Stack
            className="case-file-selector px-4 ms-auto"
            direction="horizontal"
            gap={2}
            style={{ justifyContent: 'flex-end' }}
        >
            <div className="bold color-darkgray">Zone Group</div>
            <i
                className="fal fa-check-circle fa-lg color-gray"
                onClick={handleToggleZoneGroupDetailsModal}
                style={{ cursor: 'pointer' }}
            />
            <div style={{ minWidth: 200, maxWidth: 200, flexGrow: 1 }}>
                <CheckmateSelect
                    options={caseFileModelOptions ?? []}
                    isDisabled={caseFileModelOptions?.length === 1}
                    value={caseFileModelOptions?.find((o) => o.id === caseFileModelId)}
                    onChange={handleCaseFileModelChange}
                    isLoading={userCaseFileModelsQuery?.isLoading}
                    notClearable
                />
            </div>
            <CheckmateDialog
                bodyComponent={<ZoneGroupDetailsBody />}
                cancelText="Ok"
                closeButtonClassName="btn btn-black"
                handleClose={() => setShowZoneGroupDetails(false)}
                dialogClassName="zone-group-details-dialog"
                isShowingModal={showZoneGroupDetails}
                showBackdrop
                title="Zones In Group"
            />
        </Stack>
    );
}
